module.exports = __webpack_public_path__ + "static/media/banner.f0a6aa21.png";